export default function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return (Object.getOwnPropertyNames(obj).length === 0);
    } else {
        var k;
        for (k in obj) {
            if (obj.hasOwnProperty(k)) {
                return false;
            }
        }
        return true;
    }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/moment/src/lib/utils/is-object-empty.js
// module id = 218
// module chunks = 0